var _path, _path2, _path3, _g, _path4, _path5, _path6, _g2, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComtevNgMark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 612,
    height: 707,
    viewBox: "0 0 612 707",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1666_3412)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1666_3412",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 612,
    height: 707
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M611.217 0H0V706.82H611.217V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M383.497 145.502C283.005 99.7426 192.644 142.92 157.862 219.306C117.582 307.762 157.061 433.942 207.602 477.576C208.698 478.523 209.12 480.022 208.612 481.38C203.369 495.405 194.965 504.444 182.199 506.599C178.971 507.143 177.233 511.35 179.761 513.43C196.931 527.549 218.828 538.175 240.926 541.149C243.99 541.562 245.823 537.894 244.201 535.262C236.781 523.221 237.803 510.616 244.777 497.826C245.467 496.562 246.867 495.906 248.293 496.111C314.384 505.6 435.5 452.537 475.782 364.073C510.565 287.688 483.99 191.262 383.497 145.502Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M211.496 519.875C210.828 521.094 207.829 526.313 206.308 533.759C202.735 551.235 209.786 557.446 209.714 571.142C209.674 578.805 202.484 584.148 176.254 601.122C169.944 605.531 168.26 607.309 166.777 609.225C166.127 610.213 165.686 611.234 165.086 613.161",
    stroke: "black",
    strokeWidth: 11.6386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1666_3412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.624 527.613C419.467 527.613 514.998 432.083 514.998 314.239C514.998 196.396 419.467 100.865 301.624 100.865C183.781 100.865 88.25 196.396 88.25 314.239C88.25 432.083 183.781 527.613 301.624 527.613Z",
    fill: "url(#paint0_linear_1666_3412)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1666_3412",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 612,
    height: 707
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M611.217 0H0V706.82H611.217V0Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M383.497 145.502C283.005 99.7426 192.644 142.92 157.862 219.306C117.582 307.762 157.061 433.942 207.602 477.576C208.698 478.523 209.12 480.022 208.612 481.38C203.369 495.405 194.965 504.444 182.199 506.599C178.971 507.143 177.233 511.35 179.761 513.43C196.931 527.549 218.828 538.175 240.926 541.149C243.99 541.562 245.823 537.894 244.201 535.262C236.781 523.221 237.803 510.616 244.777 497.826C245.467 496.562 246.867 495.906 248.293 496.111C314.384 505.6 435.5 452.537 475.782 364.073C510.565 287.688 483.99 191.262 383.497 145.502Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M211.496 519.875C210.828 521.094 207.829 526.313 206.308 533.759C202.735 551.235 209.786 557.446 209.714 571.142C209.674 578.805 202.484 584.148 176.254 601.122C169.944 605.531 168.26 607.309 166.777 609.225C166.127 610.213 165.686 611.234 165.086 613.161",
    stroke: "black",
    strokeWidth: 11.6386,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1666_3412)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M311.526 608.989C253.861 608.989 202.43 597.3 157.234 573.922C112.816 549.765 77.7495 515.478 52.0341 471.06C26.3186 426.642 13.4609 374.043 13.4609 313.261V295.728C13.4609 234.946 26.3186 182.736 52.0341 139.097C77.7495 94.6794 112.816 60.3924 157.234 36.2354C202.43 12.0785 253.861 0 311.526 0C369.191 0 420.622 12.0785 465.819 36.2354C511.016 60.3924 546.472 94.6794 572.187 139.097C597.903 182.736 610.76 234.946 610.76 295.728V313.261C610.76 374.043 597.903 426.642 572.187 471.06C546.472 515.478 511.016 549.765 465.819 573.922C420.622 597.3 369.191 608.989 311.526 608.989ZM311.526 501.451C364.516 501.451 407.375 484.697 440.103 451.189C473.611 416.902 490.365 369.757 490.365 309.754V299.235C490.365 239.231 474.001 192.476 441.272 158.968C408.544 124.681 365.295 107.537 311.526 107.537C259.316 107.537 216.457 124.681 182.949 158.968C150.221 192.476 133.856 239.231 133.856 299.235V309.754C133.856 369.757 150.221 416.902 182.949 451.189C216.457 484.697 259.316 501.451 311.526 501.451Z",
    fill: "url(#paint1_linear_1666_3412)"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M372.719 225.343C399.026 242.739 408.827 262.601 413.335 281.634C415.004 288.682 405.497 291.833 401.572 285.747C391.326 269.855 379.204 256.898 352.44 242.213C336.558 233.498 325.241 226.741 332.144 217.834C342.362 207.915 359.591 216.662 372.719 225.343Z",
    fill: "url(#paint2_linear_1666_3412)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.318 589.904C192.458 590.049 185.179 593.473 174.47 602.398C163.761 611.321 153.638 631.004 150.439 669.241C149.199 684.059 143.292 693.231 136.523 701.248",
    stroke: "url(#paint3_linear_1666_3412)",
    strokeWidth: 10.7085,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1666_3412",
    x1: 301.624,
    y1: 100.865,
    x2: 301.624,
    y2: 527.613,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1666_3412",
    x1: 312.111,
    y1: 0,
    x2: 312.111,
    y2: 608.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1666_3412",
    x1: 392.929,
    y1: 238.411,
    x2: 365.853,
    y2: 280.257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9712"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1666_3412",
    x1: 164.422,
    y1: 589.904,
    x2: 164.422,
    y2: 701.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5E28"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FE9712"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1666_3412"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 611.217,
    height: 706.82,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComtevNgMark);
export default __webpack_public_path__ + "static/media/comtev-ng-mark.a92fa96f610fc9c5a6ac660c9cafe484.svg";
export { ForwardRef as ReactComponent };